export default __webpack_public_path__ + "static/media/faq.d7781789.svg";